/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Ui_Add_ToInputs */

const en_ui_add_to = /** @type {(inputs: Ui_Add_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add to ${i?.name}`)
};

/** @type {(inputs: Ui_Add_ToInputs) => LocalizedString} */
const ar_ui_add_to = en_ui_add_to;

/** @type {(inputs: Ui_Add_ToInputs) => LocalizedString} */
const he_ui_add_to = en_ui_add_to;

/** @type {(inputs: Ui_Add_ToInputs) => LocalizedString} */
const ur_ui_add_to = en_ui_add_to;

/** @type {(inputs: Ui_Add_ToInputs) => LocalizedString} */
const es_ui_add_to = en_ui_add_to;

/** @type {(inputs: Ui_Add_ToInputs) => LocalizedString} */
const fr_ui_add_to = en_ui_add_to;

/** @type {(inputs: Ui_Add_ToInputs) => LocalizedString} */
const de_ui_add_to = en_ui_add_to;

/** @type {(inputs: Ui_Add_ToInputs) => LocalizedString} */
const pt_ui_add_to = en_ui_add_to;

/** @type {(inputs: Ui_Add_ToInputs) => LocalizedString} */
const hi_ui_add_to = en_ui_add_to;

/** @type {(inputs: Ui_Add_ToInputs) => LocalizedString} */
const bn_ui_add_to = en_ui_add_to;

/**
* | output |
* | --- |
* | "Add to {name}" |
*
* @param {Ui_Add_ToInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const ui_add_to = /** @type {((inputs: Ui_Add_ToInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Add_ToInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ui_add_to(inputs)
	if (locale === "he") return he_ui_add_to(inputs)
	if (locale === "ur") return ur_ui_add_to(inputs)
	if (locale === "es") return es_ui_add_to(inputs)
	if (locale === "fr") return fr_ui_add_to(inputs)
	if (locale === "de") return de_ui_add_to(inputs)
	if (locale === "pt") return pt_ui_add_to(inputs)
	if (locale === "hi") return hi_ui_add_to(inputs)
	if (locale === "bn") return bn_ui_add_to(inputs)
	return en_ui_add_to(inputs)
});